import { useMemo, useState } from 'react'
import { Link, useParams } from 'react-router-dom'
import { ArrowLeft, Volume2, VolumeX } from 'lucide-react'
import { GamePlayer, getGameEntry } from '@quebon/games'

const CONTENT_GAME_MATH_URL = '/admin/contents?tab=gameMath'

export default function AdminGameMathPlayer() {
  const { gameKey } = useParams<{ gameKey: string }>()
  const [isSoundOn, setIsSoundOn] = useState(true)
  const entry = gameKey ? getGameEntry(gameKey) : undefined
  const user = useMemo(() => ({ nickname: 'Teacher', id: 'admin-preview' }), [])

  if (!entry || !gameKey) {
    return (
      <main className="flex min-h-screen items-center justify-center bg-gray-950 p-6">
        <div role="alert" className="w-full max-w-md rounded-lg border border-gray-800 bg-gray-900 p-6 text-center text-white">
          <h1 className="text-lg font-bold">게임을 찾을 수 없습니다</h1>
          <p className="mt-2 text-sm text-gray-400">요청한 게임 키를 확인해 주세요.</p>
          <Link to={CONTENT_GAME_MATH_URL} className="mt-5 inline-flex rounded-lg bg-primary-600 px-4 py-2 text-sm font-semibold text-white">
            콘텐츠 관리로 돌아가기
          </Link>
        </div>
      </main>
    )
  }

  return (
    <main className="flex h-screen flex-col overflow-hidden bg-black">
      <header className="flex h-12 shrink-0 items-center justify-between bg-gray-900 px-4 text-white">
        <Link
          to={CONTENT_GAME_MATH_URL}
          className="inline-flex items-center gap-1.5 rounded bg-gray-800 px-3 py-1.5 text-sm font-semibold hover:bg-gray-700"
          aria-label="콘텐츠 관리로 돌아가기"
        >
          <ArrowLeft size={16} aria-hidden /> 콘텐츠 관리
        </Link>
        <div className="min-w-0 px-4 text-center">
          <span className="block truncate text-sm font-semibold">{entry.ko.name}</span>
          <span className="block truncate text-xs text-gray-400">{gameKey}</span>
        </div>
        <button
          type="button"
          onClick={() => setIsSoundOn((value) => !value)}
          aria-pressed={isSoundOn}
          aria-label={isSoundOn ? '음소거' : '소리 켜기'}
          className="inline-flex items-center gap-1.5 rounded bg-gray-800 px-3 py-1.5 text-sm font-semibold hover:bg-gray-700"
        >
          {isSoundOn ? <Volume2 size={16} aria-hidden /> : <VolumeX size={16} aria-hidden />}
          {isSoundOn ? 'ON' : 'OFF'}
        </button>
      </header>
      <div className="relative flex-1 overflow-hidden">
        <GamePlayer
          gameKey={gameKey}
          user={user}
          isSoundOn={isSoundOn}
          onClose={() => {}}
          loadingFallback={<div className="flex h-full items-center justify-center text-sm text-white">Loading...</div>}
        />
      </div>
    </main>
  )
}
